import { useState, useEffect } from 'react';

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  lgxl: 1100,
  xl: 1280,
  '2xl': 1536,
};

type Breakpoint = keyof typeof breakpoints;
type Side = 'up' | 'down';

export function useBreakpoint(breakpoint: Breakpoint, side: Side = 'down') {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const width = breakpoints[breakpoint];
    const mediaQuery =
      side === 'up'
        ? window.matchMedia(`(min-width: ${width + 1}px)`)
        : window.matchMedia(`(max-width: ${width}px)`);

    const handleChange = (e: MediaQueryListEvent) => setMatches(e.matches);

    setMatches(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [breakpoint, side]);

  return matches;
}
